module.exports = __webpack_public_path__ + "img/remark.c9f2019c.png";